export const loginStatus = async () => {
  const response = await fetch("/api/auth/login-status", {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
    },
  });
  console.log(response);
  return response.json();
}

export const getUser = async () => {
  console.log("LAUNCHget user");
  const response = await fetch("/api/user/me/get-connected-user", {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
    },
  });

  return response.json();

}
